import { AppRoute } from '@/constants'
import { logout } from '@/modules/authentication/authenticationService'
import { useAuth } from '@/modules/authentication/authStore'
import { setLayout } from '@/services/localStorage'
import { createRouter, createWebHistory } from 'vue-router'
import { privateRoutes } from './privateRoutes'
import { publicRoutes } from './publicRoutes'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    ...publicRoutes,
    ...privateRoutes,
  ],
})

router.beforeEach(async (to, from, next) => {
  const store = useAuth()
  const currentUserId = to.query.currentUserId || from.query.currentUserId

  try {
    await store.authLoaded

    if (to.query.layout === 'blank' && to.name !== AppRoute.Login.name) {
      setLayout(to.query.layout)
    }

    if (currentUserId && currentUserId !== store.user?.guidId) {
      await logout()
    }

    if (to.meta.requiresAuth && !store.user) {
      return next({
        name: AppRoute.Login.name,
        query: { redirect: to.name as string },
      })
    }

    if (store.user && !store.isAuthorize(to.meta.authorities as number[])) {
      return next({ name: 'Forbidden' })
    }

    return next()
  }
  catch (error) {
    console.debug('Authentication failed:', error)
    return next({ name: AppRoute.Login.name })
  }
})

export default router
